// SY07 검색조건 저장/복원 순수 변환 — request 비의존 모듈 (GL11 mapping.ts 준용). 폼 값 변환은 index.tsx(컨덕터 뷰 키)가 한다.
// 마지막 조회 조건을 메뉴 세션(sessionStorage)·URL 쿼리에 남겨 다른 메뉴를 다녀와도 유지한다(MOMS 공통 UX — ST09 searchQuery.ts 선례).
// 저장 형태는 CommonCodeParams 그대로 — Utils.qsStringify(comma) ↔ useParsedQuery(comma) 왕복.
// 다건(codeGrps/codes)은 항목이 하나면 파서가 문자열을 주므로 asList 로 양쪽을 모두 받는다.
import type { CommonCodeParams } from './useGetCommonCodeList'

const strOrUndef = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v.trim() : undefined)

/** 문자열 배열만 남긴다 — comma 파서의 단건 문자열/다건 배열 겸용, 조작된 URL(객체 등)은 버린다 */
export const asList = (v: unknown): string[] | undefined => {
  if (Array.isArray(v) && v.length && typeof v[0] !== 'object') return v.map(String)
  return typeof v === 'string' && v.trim() ? [v.trim()] : undefined
}

/**
 * URL 쿼리(파싱 결과) → 복원 검색조건. 화주(필수 필터)가 없으면 복원 대상이 아니다(undefined).
 * 조작된 URL 이 폼/쿼리를 깨뜨리지 않도록 타입이 맞는 값만 받는다.
 */
export const fromSearchQuery = (query: Record<string, unknown>): CommonCodeParams | undefined => {
  const shipperCode = strOrUndef(query.shipperCode)
  if (!shipperCode) return undefined
  return {
    shipperCode,
    codeGrps: asList(query.codeGrps),
    codes: asList(query.codes),
  }
}
